import Swiper from 'swiper/bundle';
export function PDPFunctions() {
  var swiperRecomended = new Swiper('.recomendedProducts', {
    slidesPerView: 1.90,
    spaceBetween: 10,
    grabCursor: true,
    centeredSlides: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 10
      },
      320: {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 10
      },
      1001: {
        slidesPerView: 1.30,
        spaceBetween: 0,
        centeredSlides: true
      },
      1280: {
        slidesPerView: 1.30,
        spaceBetween: 0,
        centeredSlides: true
      },
      1281: {
        slidesPerView: 1.70,
        spaceBetween: 0,
        centeredSlides: true
      }
    },
    on: {
      afterInit: function afterInit(swiper) {
        var activeIndex = swiper.activeIndex || 0;
        var activeSlide = document.querySelectorAll('.swiper-slide')[activeIndex];
        var color = activeSlide ? activeSlide.getAttribute('data-color-product') : '#FF9214';
        document.querySelector('.recomendedProd').style.backgroundColor = color;
      },
      slideChange: function slideChange() {
        var activeIndex = swiperRecomended.activeIndex;
        var activeSlide = document.querySelectorAll('.swiper-slide')[activeIndex];
        var color = activeSlide ? activeSlide.getAttribute('data-color-product') : '#FF9214';
        document.querySelector('.recomendedProd').style.backgroundColor = color;
      }
    }
  });
  var seeMoreBtn = document.querySelector('.see-more-btn');
  var descriptionContent = document.querySelector('.product__description .description-content');
  var accordionToggle = document.querySelector('.accordion-toggle');
  var accordionContent = document.querySelector('.accordion-content');
  var icon = accordionToggle === null || accordionToggle === void 0 ? void 0 : accordionToggle.querySelector('.iconPlu');
  if (seeMoreBtn && descriptionContent) {
    var isExpanded = true;

    // Seleccionamos tanto los 'div' como los 'p'
    var paragraphs = descriptionContent.querySelectorAll('div, p');

    // Aseguramos que todos los elementos sean visibles inicialmente
    paragraphs.forEach(function (p) {
      p.style.display = 'block';
    });
    seeMoreBtn.addEventListener('click', function () {
      if (isExpanded) {
        // Ocultar todos excepto el primer 'div' y el primer 'p'
        var firstDivVisible = false;
        var firstPVisible = false;
        paragraphs.forEach(function (p) {
          if (p.tagName.toLowerCase() === 'div' && !firstDivVisible) {
            firstDivVisible = true; // Primer 'div' visible
          } else if (p.tagName.toLowerCase() === 'p' && !firstPVisible) {
            firstPVisible = true; // Primer 'p' visible
          } else {
            p.style.display = 'none'; // Ocultar los demás
          }
        });
        seeMoreBtn.textContent = 'See More';
      } else {
        // Mostrar todos los elementos nuevamente
        paragraphs.forEach(function (p) {
          p.style.display = 'block';
        });
        seeMoreBtn.textContent = 'See Less';
      }
      isExpanded = !isExpanded;
    });
  } else {
    console.log('seeMoreBtn or descriptionContent is missing');
  }
  if (accordionToggle && accordionContent) {
    accordionToggle.addEventListener('click', function () {
      accordionContent.classList.toggle('show');
      if (accordionContent.classList.contains('show')) {
        icon.textContent = '-';
      } else {
        icon.textContent = '+';
      }
    });
  }
}